import {library} from '@fortawesome/fontawesome-svg-core';
import {fas} from '@fortawesome/free-solid-svg-icons';

export const bootFontAwesome = () => {
    library.add(fas);
};



// WEBPACK FOOTER //
// ./src/boot/fontawesome.ts